import { defaultSchema } from 'hast-util-sanitize';

/**
 * Allow-list схема для rehype-sanitize.
 *
 * AI генерирует MD, который через `rehype-raw` пропускает любой HTML. Без этой
 * схемы возможны XSS-векторы: <script>, <iframe>, onerror=, javascript: URL.
 *
 * Разрешаем:
 * - <details>, <summary> для collapse-блоков
 * - <directive-note>, <directive-tip>, <directive-warning>, <directive-info> —
 *   кастомные теги для callouts (см. remark-directive-tags.ts)
 * - <sub>, <sup>, <u> — inline-форматирование, которое не покрывает GFM
 *
 * target/rel у ссылок добавляются в компоненте, а не из MD — поэтому target/rel
 * НЕ в allow-list атрибутов <a>.
 */
export const sanitizeSchema = {
	...defaultSchema,
	tagNames: [
		...(defaultSchema.tagNames ?? []),
		'details',
		'summary',
		'directive-note',
		'directive-tip',
		'directive-warning',
		'directive-info',
		'sub',
		'sup',
		'u',
	],
	attributes: {
		...defaultSchema.attributes,
		code: [...(defaultSchema.attributes?.code ?? []), 'className'],
		'*': [...(defaultSchema.attributes?.['*'] ?? []), 'className'],
		details: ['open'],
		a: ['href', 'title'],
		img: ['src', 'alt', 'title', 'width', 'height'],
	},
	protocols: {
		...defaultSchema.protocols,
		src: ['http', 'https'],
		href: ['http', 'https', 'mailto'],
	},
};
